module.exports = __webpack_public_path__ + "ac05cda1dd0848e9f08473ce8a903370.png";